import {
  GET_API,
  POST_API,
  PUT_API,
} from "../../Functionalities/APIs";

import { store } from "../../Functionalities/notifications";
export const showMessage = (
  message,
  type,
  title,
  insert,
  container,
  duration
) => {
  // reusable funciton
  // void 0
  store.addNotification({
    title: title,
    message: message,

    type: type, //success, default, warning, info, danger
    insert: insert, //top,bottom
    container: container, //top-left, top-right, top-center, bottom-left, bottom-right, bottom-center
    // content: <h1>Hallo</h1>,
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 0,
      click: true,
      //onScreen: true
    },
  });
};

export const MakeDeliveryBoy = async (e, data, keyword, params) => {
  if (e) {
    e.preventDefault();
  }
  let path = "/branch/adduser/";
  if (keyword == "add") {
    // alert("Add worked");
    var fdata = new FormData();
    fdata.append("user_id", data.user_id);
    fdata.append("username", data.username);
    fdata.append("password", data.password);
    fdata.append("keyword", "add_delivery_boy_id");
    fdata.append("franchise_id", data.franchise_id);
    
    // void 0
    let result = POST_API(fdata, "", path);
    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const MakeManager = async (e, data, keyword, params) => {
  if (e) {
    e.preventDefault();
  }
  let path = "/branch/adduser/";
  if (keyword == "add") {
    // alert("Add worked");
    var fdata = new FormData();
    fdata.append("user_id", data.user_id);
    fdata.append("username", data.username);
    fdata.append("password", data.password);
    fdata.append("keyword", "add_manager_by_id");
    fdata.append("branch_id", data.branch);
    // void 0
    let result = POST_API(fdata, "", path);
    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const AddMoney = async (e, data, keyword, params) => {
  if (e) {
    e.preventDefault();
  }
  let path = "/wallet/wallet/";
//   void 0
  // let path = `/wallet/wallet/?transaction_details=true&${params}`

  if (keyword == "add") {
    // alert("Add worked");
    var fdata = new FormData();
    fdata.append("user_id", JSON.stringify(data));
    // void 0
    let result = POST_API(fdata, "", path);
    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "get") {
    // alert("get worked");
    let result = GET_API("", params, path);
    return await result.then((result) => {
      // void 0
      if (result) {
        return result;
      } else {
        return 0;
      }
    });
  }

  if (keyword == "update") {
    // void 0
    var fdata = new FormData();
    fdata.append("wallet_id", JSON.stringify(data));
    let result = PUT_API(fdata, "", path);
    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};
